import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusSquare, faTrashAlt, faEdit } from '@fortawesome/free-regular-svg-icons'
import Translator from 'app/components/common/Translator';

export interface IButtonProps {
    onClick: React.MouseEventHandler<HTMLButtonElement>,
    text: string,
    buttonType?: typeof buttonTypes.add,
    addClass?: string,
    disabled?: boolean
}

export const buttonTypes = {
    add: {
        className: 'c-button--primary',
        icon: <FontAwesomeIcon icon={faPlusSquare} className='c-button__icon'></FontAwesomeIcon>
    },
    delete: {
        className: 'c-button--primary',
        icon: <FontAwesomeIcon icon={faTrashAlt} className='c-button__icon'></FontAwesomeIcon>
    },
    edit: {
        className: 'c-button--primary',
        icon: <FontAwesomeIcon icon={faEdit} className='c-button__icon'></FontAwesomeIcon>
    },
    default: {
        className: 'c-button--default',
        icon: <></>
    },
}

export const CstmBtn: React.FC<IButtonProps> = ({
    onClick,
    text,
    buttonType,
    addClass,
    disabled
}) => {
    return (
        <button
            className={'c-button ' + (buttonType ? buttonType.className : buttonTypes.default.className) + (addClass ? " " + addClass : "")}
            onClick={onClick}
            disabled={disabled ?? false}
        >
            <Translator text={text} className={"c-button__text"}/>
            {buttonType?.icon}

        </button>
    );
};